export default "__VITE_PUBLIC_ASSET__aca28f5a__"